module.exports = __webpack_public_path__ + "img/popular4.ee4a01ec.png";